module.exports = __webpack_public_path__ + "img/pelletspreise-vergleichen.7404df7.webp";